import {
  Accordion,
  AccordionContent,
} from '@yuno/sdk-web-core/dist/ui'
import { FC } from 'react'
import { flightDate, flightTime } from '../../../utils'
import { PURCHASE_DETAILS_ID, PURCHASE_ID } from '../order.constants'
import {
  AccordionHeadingPurchase,
  OrderDetailPurchaseDetails,
  OrderDetailPurchaseDetailsArrival,
  OrderDetailPurchaseItem,
  OrderDetailPurchaseSpanBold,
  OrderDetailPurchaseSpanRegular,
  OrderDetailPurchaseTitle,
  OrderDetailPurchaseTitleSeparator,
  OrderDetailPurchaseTitleSeparatorH,
} from '../order.styled'
import { OrderDetailPurchaseProps } from '../order.types'
import { useTranslation } from 'react-i18next'

export const OrderDetailPurchase: FC<OrderDetailPurchaseProps> = ({
  items,
}) => {
  const { t } = useTranslation()

  return (
    <Accordion>
      <AccordionHeadingPurchase
        ariaControls={PURCHASE_DETAILS_ID}
        id={PURCHASE_ID}
        open={true}
      >
        {t('Purchase details')}
      </AccordionHeadingPurchase>
      <AccordionContent ariaLabelledBy={PURCHASE_ID} id={PURCHASE_DETAILS_ID}>
        {items.map((item, index) => (
          <OrderDetailPurchaseItem key={index}>
            <OrderDetailPurchaseTitle>
              <OrderDetailPurchaseSpanRegular>
                {t('Departure Flight')}:{' '}
                <OrderDetailPurchaseSpanBold>
                  {item.flight_number}
                </OrderDetailPurchaseSpanBold>
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {flightDate(item.departure_datetime)}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseTitleSeparator />
              <OrderDetailPurchaseSpanRegular>
                {flightTime(item.departure_datetime)}
              </OrderDetailPurchaseSpanRegular>
            </OrderDetailPurchaseTitle>
            <OrderDetailPurchaseDetails>
              <OrderDetailPurchaseSpanBold>
                {t('Departure')} {item.departure_airport}
              </OrderDetailPurchaseSpanBold>
              <OrderDetailPurchaseTitleSeparatorH />
              <OrderDetailPurchaseDetailsArrival>
                <OrderDetailPurchaseSpanBold>
                  {t('Arrival')}: {item.arrival_airport}
                </OrderDetailPurchaseSpanBold>
                <OrderDetailPurchaseSpanRegular>
                  {t('Time zone')}: {item.departure_airport_timezone}
                </OrderDetailPurchaseSpanRegular>
                <OrderDetailPurchaseSpanRegular>
                  {t('Carrier code')}: {item.carrier_code}
                </OrderDetailPurchaseSpanRegular>
                <OrderDetailPurchaseSpanRegular>
                  {t('Fare basis code')}: {item.fare_basis_code}
                </OrderDetailPurchaseSpanRegular>
                <OrderDetailPurchaseSpanRegular>
                  {t('Fare class code')}: {item.fare_class_code}
                </OrderDetailPurchaseSpanRegular>
              </OrderDetailPurchaseDetailsArrival>
            </OrderDetailPurchaseDetails>
          </OrderDetailPurchaseItem>
        ))}
      </AccordionContent>
    </Accordion>
  )
}
